// @flow
import * as React from 'react';
import type { ProfileUser } from 'app/packages/pinterest-flow-types/user';
import withResource from 'app/common/lib/react/withResource';
import withRouteData from 'app/common/lib/react/withRouteData';
import { compose } from 'redux';
import { Spinner } from 'gestalt';
import FollowingTopicsContainer, {
  FollowingTopicsNuxContainer,
} from 'app/common/react/components/profile/FollowingPage/FollowingTopicsContainer';
import withViewer, { type Viewer } from 'app/common/lib/react/withViewer';

type Props = {
  params: { username: string },
  user: {
    data: ProfileUser,
    isLoaded: boolean,
  },
  viewer: Viewer,
};

function ProfileTopics({ user, viewer }: Props) {
  if (!user.isLoaded) {
    return <Spinner accessibilityLabel="Page loading..." show />;
  }

  const { data } = user;
  if (viewer.id === data.id) {
    return <FollowingTopicsNuxContainer user={data} />;
  } else {
    return <FollowingTopicsContainer user={data} />;
  }
}

export default compose(
  withViewer,
  withResource({
    name: 'UserResource',
    key: 'user',
    options: ({ params }: Props) => ({
      username: params.username,
    }),
  }),
  withRouteData({
    name: 'FollowingPage',
    routeContextLog: () => ({
      view_type: PCONST.thrift.ViewType.USER,
      view_parameter: PCONST.thrift.ViewParameterType.USER_FOLLOWING,
    }),
  }),
)(ProfileTopics);
